module.exports = __WEBPACK_EXTERNAL_MODULE_169__;


//////////////////
// WEBPACK FOOTER
// external "colors"
// module id = 169
// module chunks = 0